import React from "react";
import { Modal } from "../../components/Modal/Modal";
import { Button } from "../../components/Button/Button";
import { Form } from "../../components/Form/Form";
import { Field } from "../../components/Field/Field";
import { useCreateProject } from "../../schema";
import { useForm } from "../../lib/react-apollo-hooks-form";
import { notEmpty } from "../../validators/notEmpty";
import { ErrorView } from "../ErrorView/ErrorView";
import styles from "./CompanyDetailsView.module.scss";

export interface CreateProjectProps {
  organizationId: string;

  onModalClose(): void;
}

export const CreateProject: React.FC<CreateProjectProps> = ({
  organizationId,
  onModalClose,
}) => {
  // setup create project form
  const {
    useInput,
    loading,
    error,
    submit: createProject,
  } = useForm({
    mutation: useCreateProject,
    options: {
      refetchQueries: ["Viewer"],
      awaitRefetchQueries: true,
    },
    onSuccess: () => onModalClose(),
  });

  // configure inputs
  const nameInput = useInput({
    name: "name",
    validators: [notEmpty],
  });

  const submit = () => {
    createProject({
      organizationId,
    });
  };

  // handle save errors
  if (error) {
    return (
      <ErrorView
        title="Saving Project failed"
        error={error}
        modal={{ title: "Create Project", onModalClose }}
      />
    );
  }

  return (
    <Modal
      title="Add new Project"
      onCloseRequested={onModalClose}
      footer={
        <>
          <Button data-testid="cefjaofa888b" secondary onClick={onModalClose}>
            Cancel
          </Button>
          <Button
            data-testid="74ecfjaof9a"
            loading={loading}
            onClick={() => submit()}
          >
            Save
          </Button>
        </>
      }
    >
      <Form error={error} onSubmit={submit} className={styles["form"]}>
        <div>
          <Field {...nameInput} label="Name" short />
        </div>
      </Form>
    </Modal>
  );
};
